import { extendTheme } from '@chakra-ui/react'
import colors from './colors'
import { ButtonStyle } from './components/buttonStyle'
import { InputStyle } from './components/inputStyle'
import { MenuStyle } from './components/menuStyle'
import { ModalStyle } from './components/modalStyle'
import { TableStyle } from './components/tableStyle'

const theme = extendTheme({
	styles: {
		global: {
			body: {
				bg: '#FFFFFF',
				color: '#000',
				fontWeight: 400,
				fontSize: '14px',
			},
			p: {
				marginBottom: '0px',
			},
		},
	},
	components: {
		Button: ButtonStyle,
		Table: TableStyle,
		Input: InputStyle,
		Modal: ModalStyle,
		Menu: MenuStyle,
	},
	fonts: {
		heading: 'Avenir-Bold',
		body: 'Avenir-Regular',
	},
	colors: {
		...colors,
	},
})
export default theme
